import React, { useEffect, useState } from "react";
import Input from "./Input";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import { generateMenu } from "../../utils/MenuGenerator";
import { DayPicker, getDefaultClassNames,  } from "react-day-picker";
import "react-day-picker/style.css";
import { cn, ImgIcon } from "../../utils/utils";
import useOutsideClick from "../../hooks/useOutsideClick";
import CalendarIcon from "../../assets/icons/CalendarIcon";

type Props = {
  field: any;
  name: string;
  isDisabled?: boolean;
  label?: string;
  isRequired?: boolean;
  min?: string;
  title?: string;
  max?: string;
  customClass?: string;
  customLabelClass?: string;
  placeHolder?: string;
  handleChangeEvent?: any;
  value?: string | null;
  dateInputProps?: any;
  openModel: boolean;
  setOpenModel: any;
  dropDownClass?:string
};
const TimeSelection = ({setSelectedTime,name,formatDate,selectedTime}:any) => {
  return <div className="flex bg-white  text-base  max-h-[295px] rounded-md mt-auto border-t-2 border-b-2 border-[#f3f3f3] font-semibold">
    <div className="border-l-2 border-[#f3f3f3] p-1 overflow-y-auto hideScroll ">
      {new Array(12).fill(0).map((_, index) => {
        if(index === 0){
          return  <div key={index} className={cn("w-[40px] h-[40px] grid place-content-center hover:bg-[#ccc] hover:text-primary hover:font-bold rounded-md",String(12).padStart(2,"0") === selectedTime.hour && `bg-[#ccc] text-primary font-bold`)} onClick={()=>{
        setSelectedTime((prev:any) =>{
          return {
            ...prev,
            hour:String(12).padStart(2,"0"),
            
          }
        })
        }}>{String(12).padStart(2,"0")}</div>
        }
        return <div key={index} className={cn("w-[40px] h-[40px] grid place-content-center hover:bg-[#ccc] hover:text-primary hover:font-bold rounded-md",String(index).padStart(2,"0") === selectedTime.hour && `bg-[#ccc] text-primary font-bold`)} onClick={()=>{
        setSelectedTime((prev:any) =>{
          return {
            ...prev,
            hour:String(index).padStart(2,"0"),
            
          }
        })
        }}>{String(index).padStart(2,"0")}</div>
})}
    </div>
    <div className="border-l-2 border-[#f3f3f3] p-1 overflow-y-auto hideScroll">
      {new Array(12).fill(0).map((_, index) => (
        <div key={index} className={cn("w-[40px] h-[40px] grid place-content-center hover:bg-[#ccc] hover:text-primary hover:font-bold rounded-md",String(5*index).padStart(2,"0") === selectedTime.minute && `bg-[#ccc] text-primary font-bold`)} onClick={()=>{
        setSelectedTime((prev:any) =>{
          return {
            ...prev,
            minute:String(5*index).padStart(2,"0"),
            
          }
        })
        }}>{String(5*index).padStart(2,"0")}</div>
      ))}
    </div>
    <div className="border-l-2 border-r-2 border-[#f3f3f3] p-1">
       {['AM','PM'].map((item, index) => (
        <div key={index} className={cn("w-[40px] h-[40px] grid place-content-center hover:bg-[#ccc] hover:text-primary hover:font-bold rounded-md",item === selectedTime.period && `bg-[#ccc] text-primary font-bold`)} onClick={()=>{
        setSelectedTime((prev:any) =>{
          return {
            ...prev,
            period:item,
            
          }
        })
        }}>{item}</div>
      ))}
    </div>
    
  </div>;
};
const Footer = ({handleChangeEvent,name,formatDate,selectedDate,selectedTime,setOpenModel,setSelectedTime,setSelectedDate}:any) => {
  return <div className="flex justify-between items-center px-4 py-2 text-base font-semibold">
    <p className="text-primary" onClick={()=>{
      setSelectedDate('')
      setSelectedTime({
        hour:'12',
        minute:'00',
        period:'AM'
      })
      handleChangeEvent('',name)
    }}>Reset</p>
    <p className="text-primary" onClick={()=>{
      let hour = selectedTime.period === "PM" ? parseInt(selectedTime.hour)+12 : selectedTime.hour
      if(selectedTime.period === "PM" && selectedTime.hour === "12"){
        hour = 12
      }
      if(selectedTime.period === "AM" && selectedTime.hour === "12"){
        hour = 0
      }
      handleChangeEvent(`${selectedDate} ${String(hour).padStart(2,"0")}:${selectedTime.minute}`,name)
      setOpenModel(false)
    }  
    }>Ok</p>
  </div>;
};
type timeSlotType ={hour:string,minute:string,period:string}
function DateTimeSelection({
  field,
  name,
  isDisabled,
  label,
  isRequired = false,
  min,
  max,
  openModel,
  setOpenModel,
  handleChangeEvent,
  dateInputProps,
  title,
  placeHolder,
  customLabelClass,
  dropDownClass
}: Props) {
  
  const defaultClassNames = getDefaultClassNames();
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [selectedTime, setSelectedTime] = useState<timeSlotType >({
    hour:'12',
        minute:'00',
        period:'AM'
  } as timeSlotType);
  const formatDate = (date: Date) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    //@ts-ignore
    return date.toLocaleDateString("en-GB", options); // e.g., "1 Jan 2025"
  };
  const handleDisabledState = () => {
    if (isDisabled) {
      return true;
    }
    if (min && max) {
      return {
        before: new Date(min),
        after: new Date(max),
      };
    }
    if (min) {
      return { before: new Date(min) };
    }
    if (max) {
      return { after: new Date(max) };
    }
  };
  const calenderMenu = [
    {
      name: "Date",
      type: "date",
      action: "setDate",
      icon: CalendarIcon,
      tag: "calender",
      color: "text-primary dark:text-white",
    },
  ];
  const menu = generateMenu(
    calenderMenu,
    {},
    {
      calender: {
        component: () => {
          return (
            <div className="mobile:max-w-[320px] mobile:overflow-auto customScroll">
              <div className="flex">
              <DayPicker
                mode="single"
                disabled={handleDisabledState()}
                className="border-t-2 border-[#f3f3f3] pl-2 pr-1 pt-1"
                selected={new Date(selectedDate)}
                classNames={{
                  selected:`${defaultClassNames.selected} bg-[#ccc] font-bold text-primary rounded-full removeBorder`,
                  day_button:`${defaultClassNames.day_button} removeBorder`,
                  day:`${defaultClassNames.day} removeBorder`,
                }}
                onSelect={(date) => {
                  setSelectedDate(formatDate(new Date(date! || "")));
                  //handleChangeEvent(formatDate(new Date(date! || "")), name);
                  
                }}
              />
              <TimeSelection setSelectedTime={setSelectedTime} name={name} formatDate={formatDate} selectedTime={selectedTime}/>
            </div>
                <Footer handleChangeEvent={handleChangeEvent} name={name} formatDate={formatDate} selectedDate={selectedDate} selectedTime={selectedTime} setOpenModel={setOpenModel} setSelectedTime={setSelectedTime} setSelectedDate={setSelectedDate}/>
            </div>
            
          );
        },
      },
    },
  );
  const divRef = React.useRef<HTMLDivElement>(null);
  useOutsideClick(divRef, () => setOpenModel(false));
  useEffect(()=>{
    if(dateInputProps?.value){
      const date = new Date(dateInputProps?.value)
      setSelectedTime({
        
        hour:String(date.getHours()%12 || 12).padStart(2,"0"),
        minute:String(date.getMinutes()).padStart(2,"0"),
        period:date.getHours() >= 12 ? "PM" : "AM"
      })
      setSelectedDate(formatDate(date)) 
    }
  },[])
  return (
    <div className="relative" ref={divRef}>
      <Input
        inputProps={{
          ...dateInputProps,
          type: "text",
          readOnly: true,
          placeholder: placeHolder || "date",
          value: dateInputProps.value || "",
          onClick: () => {
            setOpenModel(true);
          },
          style: { cursor: "pointer", outline: "none" },
        }}
        customClass={`${isDisabled && "bg-[#f3f3f3] cursor-not-allowed"}`}
        label={label || title || "Date"}
        labelStyle={customLabelClass}
        isRequired={isRequired}
      />
      {openModel && menu && (
        <DropDownBox
          dropDownConfig={menu}
          className={cn("w-[466px] mobile:max-w-[330px] left-0  pr-4  dark:bg-primary font-bold text-primary dark:text-white bottom-[0px] top-auto h-fit pl-0 pt-0",dropDownClass)}
          title=""
          closeDropDown={() => {}}
        />
      )}
    </div>
  );
}

export default DateTimeSelection;
